import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";
import rehypeSanitize from "rehype-sanitize";
import './MarkdownViewer.scss';

type WebhookData = {
  output: string;
}[];

interface MarkdownViewerProps {
  webhookData: WebhookData | string; // Может быть как объектом, так и строкой JSON
  className?: string;
}

export const MarkdownViewer: React.FC<MarkdownViewerProps> = ({ 
    webhookData,
    className = ''
 }) => {
  const [md, setMd] = useState<string>("Загрузка...");

  useEffect(() => {
    try {
      // Если данные пришли как строка JSON, парсим их
      const parsedData = typeof webhookData === 'string' 
        ? JSON.parse(webhookData) 
        : webhookData;

      if (Array.isArray(parsedData) && parsedData.length > 0) {
        const text = parsedData[0].output ?? "";
        setMd(text);
      } else {
        setMd("Нет содержимого для отображения");
      }
    } catch (e) {
      setMd("Ошибка при обработке данных");
      console.error("Ошибка парсинга webhook данных:", e);
    }
  }, [webhookData]);

  return (
    <div className={`markdown-wrapper ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkBreaks]}
        rehypePlugins={[rehypeSanitize]}
      >
        {md}
      </ReactMarkdown>
    </div>
  );
};